const fontFamilies = {
  regular:  '"OurLexend-Regular", Helvetica, sans-serif',
  semiBold: '"OurLexend-SemiBold", Helvetica, sans-serif',
  bold:     '"OurLexend-Bold", Helvetica, sans-serif',
};

const fontSizes = {
  z100: "1.2rem",
  z200: "1.4rem",
  z300: "1.6rem",
  z400: "1.8rem",
  z500: "2rem",
  z600: "2.4rem",
  z700: "3rem",
  z800: "3.6rem",
  z900: "4.4rem",
  z1000: "5.4rem"
};

const fontWeights = {
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500 //to be added to storybook
};

const lineHeight = {
  regular: 1.2,
  medium: 1.5
};

export { fontFamilies, fontSizes, fontWeights, lineHeight };
